import React from 'react';
import { AlertCircle } from 'lucide-react';
export function Problem() {
  return <section className="py-8 md:py-12 px-5 bg-cream-50" data-id="element-229">
      <div className="max-w-3xl mx-auto" data-id="element-230">
        <div className="text-center mb-10 md:mb-12" data-id="element-231">
          <h2 className="font-serif font-medium text-3xl md:text-4xl text-ink-900 leading-tight" data-id="element-232">
            ¿Te ha pasado alguna vez?
          </h2>
        </div>

        <div className="bg-cream-100 rounded-3xl p-6 md:p-10 border border-cream-300 mb-10" data-id="element-233">
          <ul className="space-y-4 md:space-y-5" data-id="element-234">
            {['Te sientes mal y terminas buscando en Google', 'Encuentras respuestas contradictorias', 'No sabes en cuál confiar', 'Terminas recurriendo siempre a lo mismo', 'Sientes que dependes de internet para cualquier molestia cotidiana'].map((item, idx) => <li key={idx} className="flex items-start gap-3 md:gap-4" data-id="element-235">
                <div className="mt-1 flex-shrink-0 w-6 h-6 rounded-full bg-terracotta-100 flex items-center justify-center" data-id="element-236">
                  <AlertCircle className="w-3.5 h-3.5 text-terracotta-600" strokeWidth={2.5} data-id="element-237" />
                </div>
                <span className="text-base md:text-lg text-ink-800 leading-snug" data-id="element-238">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="bg-olive-700 text-cream-50 rounded-2xl p-8 md:p-10 text-center shadow-xl relative overflow-hidden" data-id="element-239">
          <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-cream-50 to-transparent" data-id="element-240"></div>
          <div className="relative z-10" data-id="element-241">
            <p className="font-serif text-2xl md:text-3xl font-medium leading-tight mb-3" data-id="element-242">
              No necesitas más información.
            </p>
            <p className="font-serif text-2xl md:text-3xl font-medium leading-tight text-olive-200" data-id="element-243">
              Necesitas tenerla organizada.
            </p>
          </div>
        </div>
      </div>
    </section>;
}